import eventEmitter from '../../foreground/contentFramePortalGateInternalMethods/eventEmitter';
// eslint-disable-next-line import/no-cycle
import { getScrollingManager } from './getScrollingManager';
import type { MobileContentFrameWindow } from './types';

declare let window: MobileContentFrameWindow;

/**
 * Allows handling of a tap event.
 *
 * This is similar to the 'touchend' event, but does not trigger on dragging.
 */
const tap = (element: HTMLElement, callback: (event: Event) => void) => {
  let startX = 0;
  let startY = 0;

  element.addEventListener('touchstart', (event) => {
    startX = event.touches[0].clientX;
    startY = event.touches[0].clientY;
  });

  element.addEventListener('touchend', (event) => {
    const deltaX = Math.abs(event.changedTouches[0].clientX - startX);
    const deltaY = Math.abs(event.changedTouches[0].clientY - startY);

    // If the user dragged more than 10px, we don't consider it a tap.
    // This allows for small movements during a tap.
    if (deltaX > 10 || deltaY > 10) {
      return;
    }

    callback(event);
  });
};

interface ToggleSummaryArgs {
  summaryContainer: HTMLElement;
  topLine: HTMLElement;
  chevronIcon: HTMLElement;
}

const toggleSummary = ({ summaryContainer, topLine, chevronIcon }: ToggleSummaryArgs) => (event: Event) => {
  const scrollingManager = getScrollingManager('toggleSummary');
  event.stopPropagation();
  scrollingManager.disableAllPaginationElements();

  summaryContainer.classList.toggle('summary-container-expanded');
  topLine.classList.toggle('summary-top-line-expanded');
  chevronIcon.classList.toggle('toggle-icon-expanded');

  window.portalGateToForeground.emit('summary-container-toggled');
  // Emit the same event through eventEmitter so we can use it inside the
  // content frame's YouTube teleprompter
  eventEmitter.emit('summary-container-toggled');

  setTimeout(() => {
    scrollingManager.onResize(true);
    scrollingManager.enableAllPaginationElements();
  }, 400);
};

export const setupMetadata = () => {
  const summaryToggle = document.getElementById('summary-toggle');
  const summaryContainer = document.getElementById(
      'summary-container-wrapper',
    );

  if (!summaryToggle || !summaryContainer) {
    return;
  }

  const chevronIcon = document.getElementById('toggle-icon');
  const topLine = document.getElementById('summary-top-line');

  if (!chevronIcon || !topLine) {
    return;
  }


  const toggleSummaryHandler = toggleSummary({ summaryContainer, topLine, chevronIcon });

  tap(summaryToggle, toggleSummaryHandler);
  tap(summaryContainer, toggleSummaryHandler);

    // On regular scroll, the native elements are triggered on the 'click' event,
    // whereas on paginated scroll they are handled by touch. Thus, we prevent 'click'
    // events from bubbling up to the webview in case we are in regular scroll mode.
  summaryToggle.addEventListener('click', (event) => event.stopPropagation());
  summaryContainer.addEventListener('click', (event) => event.stopPropagation());
};
